var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base_color"},[_c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"crossBox"},[_c('van-icon',{staticClass:"cross",attrs:{"name":"cross"},on:{"click":_vm.close}})],1),_c('div',{staticClass:"myPopupContentCenter"},[_c('PuPdf',{attrs:{"urlLink":_vm.urlLink}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }